import { ACTION } from "./const";

export const getList = () => ({
  type: ACTION.GET_LIST
});
